module.exports = __webpack_public_path__ + "img/shtg.0e0694b2.png";